import {
  Button,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import InputField from "../../../FormComponents/InputField";
import { getUser } from "../../../Utils/Common";
import FormAlert from "../../../components/FormAlert";
import { makeStyles } from "@mui/styles";
import {
  addExportProduct,
  checkBarcode,
  getExCategoryById,
} from "../../../services/Export";
import { Validators } from "../../../Validation/FormValidation";
import Ex_ItemFormValidation from "../../../Validation/Ex_ItemFormValidation";
import Ex_CategorySelectingPopup from "../../../components/Ex_CategorySelectingPopup";

const useStyles = makeStyles({
  categoryContainer: {
    padding: "10px",
  },
  categoryTag: {
    marginRight: "10px",
  },
});

function Ex_ItemForm({ setOpenForm }) {
  const classes = useStyles();

  // Form values - REMOVED items/materials
  const [values, setValues] = useState({
    _barcode: "",
    _productName: "",
    _ProductNote: "",
    _categories: [],
  });

  // Reset values
  const resetValues = () => {
    setError({ _barcode: "", _productName: "" });
    setSelectedCatgory([]);
    setExportCategories([]);
    closeAlert();
    setValues({
      _barcode: "",
      _productName: "",
      _ProductNote: "",
      _categories: [],
    });
  };

  // Alerts
  const [displayAlert, setAlert] = useState(false);
  const [alertData, setAlertData] = useState({
    type: "",
    message: "",
  });

  const closeAlert = () => {
    setAlert(false);
    setAlertData({
      type: "",
      message: "",
    });
  };

  // Category management
  const [openCatgoryTable, setOpenCatgoryTable] = useState(false);
  const [selectedCatgory, setSelectedCatgory] = useState([]);
  const [exportCategories, setExportCategories] = useState([]);
  const [catgoryRows, setCatgoryRows] = useState([]);

  // Errors for input fields
  const [error, setError] = useState({
    _barcode: "",
    _productName: "",
  });

  const handleChange = (name, val) => {
    setError({
      _barcode: "",
      _productName: "",
    });
    closeAlert();
    setValues({
      ...values,
      [name]: val,
    });
  };

  const handleOpenCategoryTable = async () => {
    setOpenCatgoryTable(true);
  };

  const handleCloseCatgoryTable = async () => {
    const categoryList = [];
    for (let x = 0; x < selectedCatgory.length; x++) {
      let categoryData = await getExCategoryById(selectedCatgory[x]);
      categoryList.push(categoryData);
    }
    setExportCategories(categoryList);
    setValues({
      ...values,
      _categories: selectedCatgory,
    });
    setOpenCatgoryTable(false);
  };

  const submitValue = async () => {
    console.log(values);
    let errorMsg = Ex_ItemFormValidation(values);
    setError(errorMsg);

    if (!errorMsg._barcode && !errorMsg._productName) {
      console.log(errorMsg);
      let _barcode = await checkBarcode(values._barcode);
      if (_barcode) {
        setError({
          ...error,
          _barcode: "Barcode already exists",
        });
      } else if (!_barcode) {
        // Get user name
        let user = getUser();

        // UPDATED: Removed items from product body
        // Materials will be managed separately via ProductionMaterials
        const productBody = {
          name: values._productName,
          barcode: values._barcode,
          categories: values._categories,
          status: "ACTIVE",
          addedBy: user.username,
          note: values._ProductNote,
          // REMOVED: items field
        };

        console.log(productBody);

        let result = await addExportProduct(productBody);

        if (result) {
          resetValues();
          setAlertData({
            type: "success",
            message:
              "Product created successfully! You can now add materials via the 'Manage Materials' option.",
          });
          setAlert(true);
        } else {
          setAlertData({
            type: "error",
            message: "Something went wrong...",
          });
          setAlert(true);
        }
      } else {
        // Server error
        setAlertData({
          type: "error",
          message: "Server error occurred",
        });
        setAlert(true);
      }
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={11} sx={12}>
        <Typography mt={1} variant="h6">
          Add Export Product
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Note: Materials (BOM) can be added after creating the product via
          "Manage Materials"
        </Typography>
      </Grid>
      <Grid item xs={12} sm={1} sx={12}>
        <Tooltip title="Close">
          <IconButton
            onClick={() => {
              setOpenForm(false);
            }}
            aria-label="close"
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Grid>

      <Grid item xs={12} sm={4} sx={12}>
        <InputField
          name="_barcode"
          errorMsg={error._barcode}
          value={values._barcode}
          onChange={(event, newInputValue) =>
            handleChange(event, newInputValue)
          }
          type="text"
          label="Barcode"
          validators={[{ check: Validators.required }]}
        />
      </Grid>

      <Grid item xs={12} sm={8} sx={12}>
        <InputField
          name="_productName"
          errorMsg={error._productName}
          value={values._productName}
          onChange={(event, newInputValue) =>
            handleChange(event, newInputValue)
          }
          type="text"
          label="Product Name"
          validators={[{ check: Validators.required }]}
        />
      </Grid>

      {exportCategories.length !== 0 ? (
        <Grid item xs={12} sm={12} sx={12}>
          <Paper
            className={classes.categoryContainer}
            onClick={handleOpenCategoryTable}
            sx={{ cursor: "pointer", "&:hover": { bgcolor: "action.hover" } }}
          >
            <Typography variant="subtitle2" gutterBottom>
              Categories
            </Typography>
            <Grid container spacing={1}>
              {exportCategories.map((category, index) => (
                <Grid item key={index}>
                  <Chip label={category.category} variant="outlined" />
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Grid>
      ) : (
        <Grid item xs={12} sm={12} sx={12}>
          <Button
            onClick={handleOpenCategoryTable}
            variant="outlined"
            fullWidth
          >
            Select Categories
          </Button>
        </Grid>
      )}

      {/* REMOVED: Items/Materials selection section
          Materials are now managed separately via ProductionMaterials
          after the product is created */}

      <Grid item xs={12} sm={12} sx={12}>
        <InputField
          name="_ProductNote"
          value={values._ProductNote}
          onChange={(event, newInputValue) =>
            handleChange(event, newInputValue)
          }
          type="text"
          label="Note"
          multiline={true}
          rows={3}
        />
      </Grid>

      <Grid item xs={12} sm={12} sx={12}>
        {displayAlert ? (
          <FormAlert type={alertData.type} message={alertData.message} />
        ) : null}
      </Grid>

      <Grid item xs={12} sm={12} sx={12}>
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xs={12} sm={4}>
            <Button fullWidth variant="contained" onClick={submitValue}>
              Submit
            </Button>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button fullWidth onClick={resetValues} variant="outlined">
              Reset
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        {openCatgoryTable ? (
          <Ex_CategorySelectingPopup
            setOpenCatgoryTable={setOpenCatgoryTable}
            openCatgoryTable={openCatgoryTable}
            handleCloseCatgoryTable={handleCloseCatgoryTable}
            setSelectedCatgory={setSelectedCatgory}
            selectedCatgory={selectedCatgory}
            setCatgoryRows={setCatgoryRows}
            catgoryRows={catgoryRows}
          />
        ) : null}
      </Grid>
    </Grid>
  );
}

export default Ex_ItemForm;
